/**
 * Helper integrasi CDN (https://cdn-1.klaten.go.id) lewat PHP proxy di folder api/.
 *
 * Kenapa harus lewat proxy:
 * - Upload/delete/crypto butuh X-API-KEY yang tidak boleh dibongkar ke browser.
 * - File di CDN baru bersifat private, harus ditampilkan lewat proxy-file.
 *
 * Data lama (fileurl/fileuri) masih tersimpan sebagai URL publik CDN lama
 * (https://cdn-1.klaten.go.id/...). Untuk data itu tetap dicoba lewat proxy dulu,
 * proxy backend yang akan redirect 302 ke CDN lama kalau file tidak ada di CDN baru.
 */

const LEGACY_CDN_BASE_URL = 'https://cdn-1.klaten.go.id'

function getProxyBaseUrl() {
  if (process.env.NODE_ENV === 'production') {
    return `${window.location.origin}/api`
  }

  // Lokal: pakai proxy Vue CLI devServer ('/api/cdn' -> http://localhost:8081/cdn)
  // supaya tidak kena masalah CORS/port berbeda saat `npm run serve`.
  return '/api'
}

export const CDN_UPLOAD_ENDPOINT = {
  image: `${getProxyBaseUrl()}/cdn/image.php`,
  file: `${getProxyBaseUrl()}/cdn/file.php`,
  delete: `${getProxyBaseUrl()}/cdn/delete.php`
}

// Alias sesuai penamaan di prompt integrasi (imageUploadUrl / pdfUploadUrl)
export const imageUploadUrl = CDN_UPLOAD_ENDPOINT.image
export const pdfUploadUrl = CDN_UPLOAD_ENDPOINT.file
export const deleteUrl = CDN_UPLOAD_ENDPOINT.delete

/**
 * Ambil fullpath yang harus disimpan ke API aplikasi dari respon upload proxy.
 * JANGAN simpan fileuri / stream_uri / token.
 */
export function getCdnStoredPath(uploaded) {
  if (!uploaded) return ''

  const data = uploaded.data || uploaded

  return data.fullpath || data.filepath || data.path || ''
}

function isBlobOrDataUrl(value) {
  return value.startsWith('blob:') || value.startsWith('data:')
}

function isLocalAsset(value) {
  return value.startsWith('/img/') || value.startsWith('/assets/') || value.startsWith('/icon')
}

function extractFilepath(value) {
  if (value.startsWith(LEGACY_CDN_BASE_URL)) {
    return value.slice(LEGACY_CDN_BASE_URL.length)
  }

  // URL http(s) lain (bukan CDN lama) -> bukan sesuatu yang bisa di-proxy, biarkan apa adanya.
  if (/^https?:\/\//i.test(value)) {
    return null
  }

  return value
}

/**
 * URL untuk menampilkan file (gambar/dokumen) lewat proxy.
 * Menerima baik fullpath baru (/sifasum/image/xxx.png) maupun URL publik lama
 * (https://cdn-1.klaten.go.id/sifasum/image/xxx.png), dan tetap mengarahkannya
 * lewat proxy-file supaya fallback data lama otomatis ditangani backend.
 */
export function getCdnDisplayUrl(value) {
  if (!value || typeof value !== 'string') return ''

  if (isBlobOrDataUrl(value) || isLocalAsset(value)) {
    return value
  }

  const filepath = extractFilepath(value)

  if (filepath === null) {
    // URL eksternal non-CDN (mis. aset pihak ketiga), tampilkan langsung.
    return value
  }

  const normalized = filepath.startsWith('/') ? filepath : `/${filepath}`

  return `${getProxyBaseUrl()}/cdn/proxy-file.php?filepath=${encodeURIComponent(normalized)}`
}

/**
 * Fallback FE: dipakai di @error pada <img>/<v-img> kalau proxy gagal load,
 * langsung arahkan ke URL publik CDN lama.
 */
export function getCdnLegacyDisplayUrl(value) {
  if (!value || typeof value !== 'string') return ''

  if (value.startsWith(LEGACY_CDN_BASE_URL)) {
    return value
  }

  let filepath = value
  if (/^https?:\/\//i.test(filepath)) {
    filepath = filepath.replace(/^https?:\/\/[^/]+/, '')
  }

  filepath = filepath.startsWith('/') ? filepath : `/${filepath}`

  return `${LEGACY_CDN_BASE_URL}${filepath}`
}
